import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Slide,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const AccountStatusDialog = ({ open, onClose, title, description }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "24px",
          width: { xs: "90%", sm: "400px" },
          maxWidth: "100%",
        },
      }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up", timeout: 300 }}
    >
      <DialogContent sx={{ textAlign: "center", p: 0 }}>
        <ErrorIcon sx={{ color: "#EF4444", fontSize: "48px", mb: 2 }} />
        <DialogTitle
          sx={{ color: "#12243C", fontWeight: 600, fontSize: "20px", p: 0, mb: 1 }}
        >
          {title}
        </DialogTitle>
        <Typography
          variant="body1"
          sx={{ fontSize: "14px", color: "#6B7280", lineHeight: 1.6 }}
        >
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pt: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#0073A6",
            textTransform: "none",
            padding: "10px 24px",
            borderRadius: "8px",
            "&:hover": { backgroundColor: "#005A8A" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountStatusDialog;
